import { StatsigOptions } from '@statsig/react-bindings'
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics'

import { STATSIG_ENV } from '@src/config/env'

export function getStatsigOptions(): StatsigOptions {
  const options: StatsigOptions = {
    plugins: [new StatsigAutoCapturePlugin()],
    environment: {
      tier: STATSIG_ENV,
    },
    disableStorage: true, // Disable statsig caching to avoid hydration errors due to caching on client side.
  }
  return options
}
